import React from 'react';
import { InputGroup, Form } from 'react-bootstrap';

function TextArea(props) {
    const handleChange = (value) => {
        if (props.onChange != undefined) {
            props.onChange(value);
        }
    }

    return(
        <InputGroup className="mb-3">
            {props.title != undefined ?
                <InputGroup.Prepend>
                    <InputGroup.Text>{props.title}</InputGroup.Text>
                </InputGroup.Prepend>
            : null}
            <Form.Control as="textarea" rows={props?.options?.rows ?? 5} placeholder={props.placeholder} disabled={props.disabled} type={props.type} onChange={(evt) => handleChange(evt.currentTarget.value)} value={props.value != undefined && props.value != "" ? props.value : (props.defaultValue != undefined ? props.defaultValue : "")} />
        </InputGroup>
    );
}

export default TextArea;